var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input" }, [
    _c("h2", { staticClass: "input__title" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      staticClass: "input__input",
      class: { "input__input--active": _vm.active },
      attrs: { placeholder: _vm.placeholder, disabled: _vm.disabled },
      domProps: { value: _vm.value },
      on: {
        input: function($event) {
          return _vm.$emit("input", $event.target.value)
        }
      }
    }),
    _vm._v(" "),
    _c("p", { staticClass: "input__subline" }, [_vm._v(_vm._s(_vm.subline))])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e976a11", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e976a11","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegistrationInput.vue
// module id = null
// module chunks = 